import {
  createSelector,
  createStructuredSelector,
  defaultMemoize,
} from 'reselect';

import {
  compact,
  filter,
  flow,
  get,
  map,
  split,
  zipObject,
  range,
} from 'lodash/fp';

import sanitizeHtml from 'helpers/sanitizeHtml';

const COLUMN_COUNT = 4;

const getColumns = defaultMemoize((footer) =>
  flow(
    range(0),
    map((index) => ({
      title: footer[`footer_${index + 1}_title`],
      items: flow(
        split('|'),
        compact,
        map(flow(split(';'), zipObject(['name', 'link']))),
      )(footer[`footer_${index + 1}_links`]),
    })),
    filter(({ items }) => items.length),
  )(COLUMN_COUNT),
);

const getCountries = createSelector(
  get(['countries']),
  flow(
    split('|'),
    map(
      flow(
        split(';'),
        zipObject(['language', 'country', 'link']),
        ({ country, link }) => ({
          country,
          link,
          iconName: `${link.slice(-3, -1)}Flag`,
          title: `${country}: ${link.slice(8, -1)}`,
        }),
      ),
    ),
  ),
);

const getRate = createSelector(get('footer_text'), sanitizeHtml);

const getFooter = createStructuredSelector({
  columns: getColumns,
  copyright: get('copyrights'),
  rate: getRate,
  ssl: get('certificate_lock_text_1'),
  countries: getCountries,
  emailSubscriptionContent: get(['email-subscription-content']),
});

export default createSelector(
  get(['result', 'content']),
  flow(JSON.parse, getFooter),
);
